/*
 * ******************************************************************************
 * AUTORIZACIÓN Y ASUNTOS DE USUARIOS.                                          *
 * ******************************************************************************
 */
import _ from "lodash";
//import Vue from 'vue';

export const getIsAuthenticating = function (state) {
    return !!state.isAuthenticating;
};


/**
 * Retorna true en caso de que el usuario esté autenticado.
 * @param {any} state
 */
export const isAuthenticated = function (state) {
    /**
     * Token present but no outdated, clean
     */
    return (
        state.auth.jwtToken !== null && state.auth.jwtToken.access_token !== null
    );
};
/**
 * Retorna el token de seguridad.
 * @param {any} state
 */
export const jwtToken = function (state) {
    return state.auth.jwtToken;
};

/**
 * Retorna true en caso de que el usuario esté autenticado.
 * @param {any} state
 */
export const isAuthenticatedExpired = function (state) {
    /**
     * Token present but outdated
     */
    if (
        state.auth.jwtToken !== null &&
        state.auth.jwtToken.access_token !== null &&
        new Date(state.auth.jwtToken.access_token_expiration) < new Date()
    ) {
        return false;
    } else if (
        state.auth.jwtToken !== null &&
        state.auth.jwtToken.access_token !== null &&
        new Date(state.auth.jwtToken.access_token_expiration) > new Date()
    ) {
        return false;
    }
    return null;
};
/**
 * Getter para obtener el estado de flujo de autenticación.
 * @param {any} state
 */
export const isAuthReady = function (state) {
    return state.auth.isAuthReady;
};
/**
 * Getter para obtener el estado de flujo de autenticación parte carga de api.
 * @param {any} state
 */
export const isBackLogin = function (state) {
    return state.auth.isBackLogin;
};
/**
 * Getter para obtener el estado de error de autenticación.
 * @param {any} state
 */
export const isLoginError = function (state) {
    return state.auth.isLoginError;
};

/**
 * Devuelve el email del usuario.
 * @param {any} state
 */
export const UserName = function (state) {
    var user = "";
    try {
        user = state.auth.jwtToken.user_name;
    } catch (e) { }
    return user;
};
/**
 * Devuelve el nombre del usuario.
 * @param {any} state
 */
export const UserFullName = function (state) {
    var user = "";
    try {
        user = state.auth.jwtToken.user_full_name;
    } catch (e) { }
    return user;
};
/**
 * Devuelve el nombre del código de usuario (ShortName).
 * @param {any} state
 */
export const CodUser = function (state) {
    var user = "";
    try {
        user = state.auth.jwtToken.cod_user;
    } catch (e) { }
    return user;
};
/**
 * Getter para llegar hasta la lista de roles de usuario en la aplicación.
 * @param {any} state
 */
export const UserRoles = function (state) {
    //return state.auth.roles.roles;
    return state.auth.jwtToken.roles;
};
/**
 * Devuelve si el usuario tiene un rol dado.
 * @param {any} state
 * @param {any} role
 */
export const isInRole = (state, getters) => (role) => {
    if (getters.isAuthenticated) {
        let roles = getters.UserRoles;
        if (_.isArray(roles) && roles.length > 0) {
            let idx = _.indexOf(roles, role);
            return idx >= 0;
        } else {
            return false;
        }
    } else {
        return false;
    }
};

/**
 * Devuelve si el usuario tiene alguno de los roles dados.
 * @param {any} state
 * @param {any} rolesArr
 */
export const isInRoleArr = (state, getters) => (rolesArr) => {
    let bFound = false;
    /* Creamos un listado con todos los roles */
    let rolesList = rolesArr.split(",");
    /* Recorremos los roles para ver si alguno coincide con los asignados al usuario */
    for (var lCnt = 0; lCnt < rolesList.length && !bFound; lCnt++) {
        if (getters.isInRole(rolesList[lCnt].trim())) {
            bFound = true;
            break;
        }
    }
    return bFound;
};

/**
 * Getter para obtener el LangCode del state.
 * @param {any} state
 */
export const langCode = function (state) {
    return state.langCode;
};

/**
 * Getter para obtener la instancia del state.
 * @param {any} state
 */
export const instance = function (state) {
    return state.auth.jwtToken != null ? state.auth.jwtToken.instance : '';
};

/**
 * Verifica si un codParam está o no descargado y en memoria.
 * @param {any} state
 * @param {any} getters
 */
export const IsCodParamInState = (state, getters) => (codParam) => {
    /* Se itera por los paramListItem para ver si está en el el estado */
    for (var lCnt = 0; lCnt < state.paramListItems.length; lCnt++) {
        /* Si el lenguaje y el codparam están */
        if (
            state.paramListItems[lCnt].codParam == codParam &&
            state.paramListItems[lCnt].langCode == getters.langCode
        ) {
            /* Elemento encontrado en el estate ya descargado del servidor */
            return true;
        }
    }
    return false;
};

/**
 * Getter para obtener la traducción a texto de un paramList
 * @param {any} state
 * @param {any} getters
 */
export const paramListValueFor = (state, getters) => (valToTrans, codParam) => {
    /* Se itera por los paramListItem */
    for (var lCnt = 0; lCnt < state.paramListItems.length; lCnt++) {
        /* Si el lenguaje y el codparam están */
        if (
            state.paramListItems[lCnt].codParam == codParam &&
            state.paramListItems[lCnt].langCode == getters.langCode
        ) {
            /* Se itera por la colección de valores */
            for (
                var lVal = 0;
                lVal < state.paramListItems[lCnt].dictPairs.length;
                lVal++
            ) {
                /* Si coincide con los encontrados*/
                if (state.paramListItems[lCnt].dictPairs[lVal].value == valToTrans) {
                    return state.paramListItems[lCnt].dictPairs[lVal].name;
                }
            }
            /* No se ha encontrado el valor en la colección de pares se devuelve lo metido*/
            return valToTrans;
        }
    }
    /* No se ha encontrado el paramList no se ha descargado */
    return valToTrans;
};

/**
 * Getter para obtener el nombre corto de un paramList
 * @param {any} state
 * @param {any} getters
 */
export const paramListShortNameFor =
    (state, getters) => (valToTrans, codParam) => {
        /* Se itera por los paramListItem */
        for (var lCnt = 0; lCnt < state.paramListItems.length; lCnt++) {
            /* Si el lenguaje y el codparam están */
            if (
                state.paramListItems[lCnt].codParam == codParam &&
                state.paramListItems[lCnt].langCode == getters.langCode
            ) {
                /* Se itera por la colección de valores */
                for (
                    var lVal = 0;
                    lVal < state.paramListItems[lCnt].dictPairs.length;
                    lVal++
                ) {
                    /* Si coincide con los encontrados*/
                    if (state.paramListItems[lCnt].dictPairs[lVal].value == valToTrans) {
                        return state.paramListItems[lCnt].dictPairs[lVal].shortname;
                    }
                }
                /* No se ha encontrado el valor en la colección de pares se devuelve lo metido*/
                return valToTrans;
            }
        }
        /* No se ha encontrado el paramList no se ha descargado */
        return valToTrans;
    };

/**
 * Getter para obtener la lista de un paramCode
 * @param {any} state
 * @param {any} getters
 */
export const paramCodeListFor = (state, getters) => (codParam) => {
    /* Se itera por los paramListItem */
    for (var lCnt = 0; lCnt < state.paramListItems.length; lCnt++) {
        /* Si el lenguaje y el codparam están */
        if (
            state.paramListItems[lCnt].codParam == codParam &&
            state.paramListItems[lCnt].langCode == getters.langCode
        ) {
            /* Se devuelve el listado de valores */
            return state.paramListItems[lCnt].dictPairs;
        }
    }
    /* No se ha encontrado el paramList no se ha descargado */
    return null;
};

/**
 * Verifica si un codParam PARA COMBOS está o no descargado y en memoria.
 * @param {any} state
 * @param {any} getters
 */
export const IsParamIdInState = (state, getters) => (paramId) => {
    /* Se itera por los paramListItem para ver si está en el el estado */
    for (var lCnt = 0; lCnt < state.paramListCombos.length; lCnt++) {
        /* Si el lenguaje y el codparam están */
        if (
            state.paramListCombos[lCnt].paramId == paramId &&
            state.paramListCombos[lCnt].langCode == getters.langCode
        ) {
            /* Elemento encontrado en el estate ya descargado del servidor */
            return true;
        }
    }
    return false;
};
/**
 * Getter para obtener la lista de un paramId
 * @param {any} state
 * @param {any} getters
 */
export const paramIdListFor = (state, getters) => (paramId) => {
    /* Se itera por los paramListCombos */
    for (var lCnt = 0; lCnt < state.paramListCombos.length; lCnt++) {
        /* Si el lenguaje y el paramId están */
        if (
            state.paramListCombos[lCnt].paramId == paramId &&
            state.paramListCombos[lCnt].langCode == getters.langCode
        ) {
            return state.paramListCombos[lCnt].values;
        }
    }
    /* No se ha encontrado el paramId no se ha descargado */
    return null;
};

//Retornar default item combo
export const comboDefaultIItem = function (state) {
    return state.comboDefaultIItem;
};

/**
 * Getter para obtener el estado de cadauno de los componentes
 * @param {any} state
 */
export const GetComponentsActivation = function (state) {
    return state.componentsActivation;
};

/**
 * Funciones que devuelve el formateo de distintos input
 * @param {any} state
 */
export const integerFormat = () => {
    return {
        alias: "integer",
        groupSeparator: " ",
        autoGroup: true,
        allowMinus: false,
        allowPlus: false,
        autoUnmask: true,
    };
};
export const numericFormat = () => {
    return {
        alias: "numeric",
        groupSeparator: " ",
        autoGroup: true,
        digits: 2,
        autoUnmask: true,
    };
};
export const numeric3decimalsFormat = () => {
    return {
        alias: "numeric",
        groupSeparator: " ",
        autoGroup: true,
        digits: 3,
        autoUnmask: true,
    };
};
export const numeric4decimalsFormat = () => {
    return {
        alias: "numeric",
        groupSeparator: " ",
        autoGroup: true,
        digits: 4,
        autoUnmask: true,
    };
};
export const currencyFormat = () => {
    return {
        alias: "numeric",
        groupSeparator: " ",
        autoGroup: true,
        digits: 2,
        autoUnmask: true,
    };
};
export const percentageFormat = () => {
    return {
        alias: "percentage",
        groupSeparator: " ",
        autoGroup: true,
        digits: 2,
        autoUnmask: true,
        max: 100,
    };
};
/**
 * Funcion que devuelve el conjunto de widgets en el cardbuffer
 * @param {any} state
 */
export const widgetItems = function (state) {
    return state.widgetCardsBuffer.data;
};

/**
 * Funcion que devuelve la cantidad de widgets en el cardbuffer
 * @param {any} state
 */
export const widgetItemsCount = function (state) {
    return state.widgetCardsBuffer.data.length;
};

/**
 * Funcion que devuelve el estado de collapsed en el widget buffer
 * @param {any} state
 */
export const widgetItemsCollapsed = function (state) {
    return state.widgetCardsBuffer.isCollapsed;
};

export const dateFormat = () => {
    return { alias: "date", mask: "99/99/9999" };
};
export const numericNoDecimalsFormat = () => {
    return {
        alias: "numeric",
        groupSeparator: " ",
        autoGroup: true,
        digits: 0,
        autoUnmask: true,
    };
};

/**
 * Getter for a ParamList by its code, fallback allowed
 * @param {*} state
 * @param {*} getters
 */
export const GetParamListByCode = (state, getters) => (code, fallback) => {
    return getters.paramCodeListFor(code) || fallback;
};
